import React, { useEffect,useContext } from "react";
import { FormattedMessage } from "react-intl";
import useLocalStorage from "react-use-localstorage";
import { useQuery } from "react-query";
import axios from "axios";
import { useParams } from "react-router-dom";

import { PreLoader } from "../components/preloader";
import { SchedulePresentationEndpointResponseObject } from "../types/presentation";
import VideoComponent from "../components/video";
import QuizModerator from "./quiz-moderator";
import QuizUser from "./quiz-user";
import QuizAnswersWithLeaderBoard from "./quiz-answers-with-leaderboard";
import QuizHome from "../components/speaker-mode/quiz-home";
import QuizQuestions from "../components/speaker-mode/quiz-questions";
import QuizFinalPodium from "../components/speaker-mode/quiz-final-podium";
import ScreenQuestions from "../components/screen-mode/screen-questions";
import ScreenUserList from "../components/screen-mode/screen-user-list";
import QuizScreenPodium from "../components/screen-mode/quiz-final-podium";
import UserContext from "../contexts/user";
import QuizIntro from "../components/quiz-attendee/quiz-intro";
import LiveQuestions from "../components/quiz-attendee/live-questions";
import QuizAnswerPodium from "../components/speaker-mode/quiz-answer-podium";
import io, { Socket } from "socket.io-client";
import {DefaultEventsMap} from "@socket.io/component-emitter";

const VideoPresentation: React.FC<{
  locale: string;
  setLocale: any;
  socket:any
}> = ({locale, setLocale,socket}) => {


  const {
    event_slug,
    presentation_id,
    module = "video",
  } = useParams<{
    event_slug: string;
    presentation_id: string;
    module?: string;
  }>();
  const userContext = useContext(UserContext);
  const [eventPassword] = useLocalStorage(event_slug, "");
  const {setUser, setListUser, listUser} = userContext;


  useEffect(() => {

    console.log("connected---- socket",socket); // ok
    console.log("connected---- id",presentation_id); // ok

    socket.on("connect", () => {
      console.log("connected----",presentation_id); // ok

    });

    socket.emit('join', {presentationId:presentation_id}, (response:any) => {
      console.log("join",response); // ok
    });

    socket.on("disconnect", () => {
      socket.connect();

      socket.emit('join', {presentationId:presentation_id}, (response:any) => {
        console.log("join",response); // ok
      });

    });

  },[socket]);


  useEffect(  () => {
    // check user is logined if not then fetcth token for unique url
    const userList = JSON.parse(listUser);
    const getToken = async () => {
      try{
      const response = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/api/get-token`,
        {
          params: { _id: presentation_id },
        }
      );

      var {token} = response.data
      setListUser(JSON.stringify({ token }));
       console.log("GET_TOKEN",token)
      }catch(e){
        console.log("GET_TOKEN error",e)
      }
    };

     console.log("GET_TOKEN user",userList.user)
    if(userList.token === null || userList.token === undefined){
       console.log("GET_TOKEN user inside",userList.user)
      getToken();
    }

  });




  const { data, isLoading, isError } = useQuery(
    ["presentation", presentation_id],
    async () => {
      const response =
        await axios.get<SchedulePresentationEndpointResponseObject>(
          `${process.env.REACT_APP_API_ENDPOINT}/api/public/schedule/${event_slug}/${presentation_id}`,
          {
            params: { password: eventPassword },
          }
        );
      return response.data;
    }
  );

  // if (isLoading) return <PreLoader />
  if (isError || !data) return <div></div>;

  // <div className="login-landing">
  //   <div className="login-container">
  //     <div className="login"> Hello
  //       <h4><FormattedMessage id="error.retry.message" /></h4>
  //     </div>
  //   </div>
  // </div>

  const {
    data: { event, presentation },
  } = data;
   console.log(
    "module-------------------------------------------------",
    module
  );
  if (module === "quiz-moderator") {

    return (
      <QuizModerator
        locale={locale}
        setLocale={setLocale}
        presentation={presentation}
      />
    );
  }

  if (module === "quiz") {
    return (
      <QuizUser locale={locale} setLocale={setLocale} ppt={presentation} />
    );
  }


  if (module === "quiz-user-list") {
    return (
        <QuizHome event={event}
                  locale={locale}
                  setLocale={setLocale}
                  client={socket}
                  ppt={presentation}/>
    );
  }



  if (module === "quiz-questions") {
    return (
      <QuizQuestions event={event} locale={locale} setLocale={setLocale} ppt={presentation} client={socket}/>
    );
  }

  if (module === "questions") {

    console.log("quiz-action-updates",socket)

    return (
      <LiveQuestions event={event} locale={locale} setLocale={setLocale} ppt={presentation}  client={socket}/>
    );
  }



  if (module === "screen-user-list") {
    return (
      <ScreenUserList event={event} locale={locale} setLocale={setLocale} ppt={presentation} client={socket} />
    );
  }

  if (module === "screen-questions") {
    return (
      <ScreenQuestions event={event} locale={locale} setLocale={setLocale} ppt={presentation} client={socket} />
    );
  }

  // if (module === "podium") {
  //   return (
  //       <QuizAnswerPodium event={event} locale={locale} setLocale={setLocale} presentation={presentation} />
  //   );
  // }

  if (module === "final-podium") {
    return (
      <QuizFinalPodium event={event} locale={locale} setLocale={setLocale} presentation={presentation} />
    );
  }



  if (module === "screen-podium") {
    return (
      <QuizScreenPodium event={event} locale={locale} setLocale={setLocale} presentation={presentation} />
    );
  }




  if (module === "quiz-results") {
    return (
      <QuizAnswersWithLeaderBoard
        locale={locale}
        setLocale={setLocale}
        presentation={presentation}
      />
    );
  }



  if (module === "quiz-intro") {
    return (
      <QuizIntro event={event} locale={locale} setLocale={setLocale} ppt={presentation} />
    );
  }



  return (
    <VideoComponent
      locale={locale}
      setLocale={setLocale}
      event={event}
      presentation={presentation}
      forum={module === "forum"}
    />
  );
};

export default VideoPresentation;
